import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'bold', 'Bold', [["path",{"d":"M7 5h6a3.5 3.5 0 0 1 0 7h-6l0 -7"}],["path",{"d":"M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7"}]]);